import {
  daoGetRecoveryOptions,
  daoPatchRecoveryOptions,
  daoIntiateMobileVerification,
  daoResendMobileVerificationCode,
  daoDeleteMobileNumber,
  daoVerifyMobileCode,
} from 'dao/recovery-phonenumber-dao';

export const RECOVERY_PHONE_NUMBER_GET = "RECOVERY_PHONE_NUMBER_GET";
export const RECOVERY_PHONE_NUMBER_GET_SUCCESS = "RECOVERY_PHONE_NUMBER_GET_SUCCESS";
export const RECOVERY_PHONE_NUMBER_GET_FAILURE = "RECOVERY_PHONE_NUMBER_GET_FAILURE";

export const RECOVERY_PHONE_NUMBER_PATCH = "RECOVERY_PHONE_NUMBER_PATCH";
export const RECOVERY_PHONE_NUMBER_PATCH_SUCCESS = "RECOVERY_PHONE_NUMBER_PATCH_SUCCESS";
export const RECOVERY_PHONE_NUMBER_PATCH_FAILURE = "RECOVERY_PHONE_NUMBER_PATCH_FAILURE";

export const RECOVERY_PHONE_NUMBER_SEND_CODE = "RECOVERY_PHONE_NUMBER_SEND_CODE";
export const RECOVERY_PHONE_NUMBER_SEND_CODE_SUCCESS = "RECOVERY_PHONE_NUMBER_SEND_CODE_SUCCESS";
export const RECOVERY_PHONE_NUMBER_SEND_CODE_FAILURE = "RECOVERY_PHONE_NUMBER_SEND_CODE_FAILURE";

export const RECOVERY_PHONE_NUMBER_RESEND_CODE = "RECOVERY_PHONE_NUMBER_RESEND_CODE";
export const RECOVERY_PHONE_NUMBER_RESEND_CODE_SUCCESS = "RECOVERY_PHONE_NUMBER_RESEND_CODE_SUCCESS";
export const RECOVERY_PHONE_NUMBER_RESEND_CODE_FAILURE = "RECOVERY_PHONE_NUMBER_RESEND_CODE_FAILURE";

export const RECOVERY_PHONE_NUMBER_DELETE = "RECOVERY_PHONE_NUMBER_DELETE";
export const RECOVERY_PHONE_NUMBER_DELETE_SUCCESS = "RECOVERY_PHONE_NUMBER_DELETE_SUCCESS";
export const RECOVERY_PHONE_NUMBER_DELETE_FAILURE = "RECOVERY_PHONE_NUMBER_DELETE_FAILURE";

export const RECOVERY_PHONE_NUMBER_VERIFY_CODE = "RECOVERY_PHONE_NUMBER_VERIFY_CODE";
export const RECOVERY_PHONE_NUMBER_VERIFY_CODE_SUCCESS = "RECOVERY_PHONE_NUMBER_VERIFY_CODE_SUCCESS";
export const RECOVERY_PHONE_NUMBER_VERIFY_CODE_FAILURE = "RECOVERY_PHONE_NUMBER_VERIFY_CODE_FAILURE";

export const initialState = {
  data: {
    mobileNumber: '',
  },
  getMobileNumberIsLoading: false,
  isLoading: false,
};

export const getPhoneNumber = (state) => state.recoveryPhoneNumber && state.recoveryPhoneNumber.data
&& state.recoveryPhoneNumber.data.mobileNumber;

export const isLoading = (state) => state.recoveryPhoneNumber && state.recoveryPhoneNumber.isLoading;

export const getMobileNumberIsLoading = (state) => state.recoveryPhoneNumber && state.recoveryPhoneNumber.getMobileNumberIsLoading;

// ------------------------------------
// Actions
// ------------------------------------
export const recoveryPhoneNumberGetSuccess = (payload = {}) => ({
  type: RECOVERY_PHONE_NUMBER_GET_SUCCESS,
  payload,
});

export const recoveryPhoneNumberGetFailure = (payload = {}) => ({
  type: RECOVERY_PHONE_NUMBER_GET_FAILURE,
  payload,
});

export const recoveryPhoneNumberGet = () => (dispatch) => {
  dispatch({
    type: RECOVERY_PHONE_NUMBER_GET,
  });

  return daoGetRecoveryOptions().then(
    (response) => dispatch(recoveryPhoneNumberGetSuccess(response.data)),
    (ex) => {
      dispatch(recoveryPhoneNumberGetFailure(ex));
      return Promise.reject(ex);
    }
  );
};

export const recoveryPhoneNumberPatchSuccess = (payload = {}) => ({
  type: RECOVERY_PHONE_NUMBER_PATCH_SUCCESS,
  payload,
});

export const recoveryPhoneNumberPatchFailure = (payload = {}) => ({
  type: RECOVERY_PHONE_NUMBER_PATCH_FAILURE,
  payload,
});

export const recoveryPhoneNumberPatch = (authProp = '',payload) => (dispatch) => {
  dispatch({
    type: RECOVERY_PHONE_NUMBER_PATCH,
  });

  return daoPatchRecoveryOptions(authProp, payload).then(
    (response) => dispatch(recoveryPhoneNumberPatchSuccess(response.data)),
    (ex) => {
      dispatch(recoveryPhoneNumberPatchFailure(ex));
      return Promise.reject(ex);
    }
  );
};

export const recoveryPhoneNumberSendCodeSuccess = (payload = {}) => ({
  type: RECOVERY_PHONE_NUMBER_SEND_CODE_SUCCESS,
  payload,
});

export const recoveryPhoneNumberSendCodeFailure = (payload = {}) => ({
  type: RECOVERY_PHONE_NUMBER_SEND_CODE_FAILURE,
  payload,
});

export const recoveryPhoneNumberSendCode = (payload, authProp) => (dispatch) => {
  dispatch({
    type: RECOVERY_PHONE_NUMBER_SEND_CODE,
  });

  return daoIntiateMobileVerification(payload, authProp).then(
    (response) => dispatch(recoveryPhoneNumberSendCodeSuccess(response.data)),
    (ex) => {
      dispatch(recoveryPhoneNumberSendCodeFailure(ex));
      return Promise.reject(ex);
    }
  );
};

export const recoveryPhoneNumberResendCodeSuccess = (payload = {}) => ({
  type: RECOVERY_PHONE_NUMBER_RESEND_CODE_SUCCESS,
  payload,
});

export const recoveryPhoneNumberResendCodeFailure = (payload = {}) => ({
  type: RECOVERY_PHONE_NUMBER_RESEND_CODE_FAILURE,
  payload,
});

export const recoveryPhoneNumberResendCode = (id, payload) => (dispatch) => {
  dispatch({
    type: RECOVERY_PHONE_NUMBER_RESEND_CODE,
  });

  return daoResendMobileVerificationCode(id, payload).then(
    (response) => dispatch(recoveryPhoneNumberResendCodeSuccess(response.data)),
    (ex) => {
      dispatch(recoveryPhoneNumberResendCodeFailure(ex));
      return Promise.reject(ex);
    }
  );
};

export const recoveryPhoneNumberDeleteSuccess = (payload = {}) => ({
  type: RECOVERY_PHONE_NUMBER_DELETE_SUCCESS,
  payload,
});

export const recoveryPhoneNumberDeleteFailure = (payload = {}) => ({
  type: RECOVERY_PHONE_NUMBER_DELETE_FAILURE,
  payload,
});

export const recoveryPhoneNumberDelete = (authProp) => (dispatch) => {
  dispatch({
    type: RECOVERY_PHONE_NUMBER_DELETE,
  });

  return daoDeleteMobileNumber(authProp).then(
    (response) => dispatch(recoveryPhoneNumberDeleteSuccess(response.data)),
    (ex) => {
      dispatch(recoveryPhoneNumberDeleteFailure(ex));
      return Promise.reject(ex);
    }
  );
};

export const recoveryPhoneNumberVerifyCodeSuccess = (payload = {}) => ({
  type: RECOVERY_PHONE_NUMBER_VERIFY_CODE_SUCCESS,
  payload,
});

export const recoveryPhoneNumberVerifyCodeFailure = (payload = {}) => ({
  type: RECOVERY_PHONE_NUMBER_VERIFY_CODE_FAILURE,
  payload,
});

export const recoveryPhoneNumberVerifyCode = (id, payload) => (dispatch) => {
  dispatch({
    type: RECOVERY_PHONE_NUMBER_VERIFY_CODE,
  });

  return daoVerifyMobileCode(id, payload).then(
    (response) => dispatch(recoveryPhoneNumberVerifyCodeSuccess(response.data)),
    (ex) => {
      dispatch(recoveryPhoneNumberVerifyCodeFailure(ex));
      return Promise.reject(ex);
    }
  );
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [RECOVERY_PHONE_NUMBER_GET]: (state) => ({ ...state, getMobileNumberIsLoading: true }),

  [RECOVERY_PHONE_NUMBER_GET_SUCCESS]: (state, action) => {
    if (typeof action.payload === "object") {
      return {
        ...state,
        data: {
          mobileNumber: action.payload.mobileNumber,
        },
        getMobileNumberIsLoading: false,
      };
    }
    return { ...state, getMobileNumberIsLoading: false };
  },

  [RECOVERY_PHONE_NUMBER_GET_FAILURE]: (state) => ({
    ...state,
    getMobileNumberIsLoading: false,
  }),

  [RECOVERY_PHONE_NUMBER_PATCH]: (state) => ({ ...state, getMobileNumberIsLoading: true }),

  [RECOVERY_PHONE_NUMBER_PATCH_SUCCESS]: (state, action) => {
    if (typeof action.payload === "object") {
      return {
        ...state,
        data: {
          mobileNumber: action.payload.mobileNumber,
        },
        getMobileNumberIsLoading: false,
      };
    }
    return { ...state, getMobileNumberIsLoading: false };
  },

  [RECOVERY_PHONE_NUMBER_PATCH_FAILURE]: (state) => ({
    ...state,
    getMobileNumberIsLoading: false,
  }),

  [RECOVERY_PHONE_NUMBER_SEND_CODE]: (state) => ({ ...state, isLoading: true }),

  [RECOVERY_PHONE_NUMBER_SEND_CODE_SUCCESS]: (state, action) => {
    if (typeof action.payload === "object") {
      return {
        ...state,
        isLoading: false,
      };
    }
    return { ...state, isLoading: false };
  },

  [RECOVERY_PHONE_NUMBER_SEND_CODE_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

  [RECOVERY_PHONE_NUMBER_RESEND_CODE]: (state) => ({ ...state, isLoading: true }),

  [RECOVERY_PHONE_NUMBER_RESEND_CODE_SUCCESS]: (state, action) => {
    if (typeof action.payload === "object") {
      return {
        ...state,
        isLoading: false,
      };
    }
    return { ...state, isLoading: false };
  },

  [RECOVERY_PHONE_NUMBER_RESEND_CODE_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

  [RECOVERY_PHONE_NUMBER_DELETE]: (state) => ({ ...state, isLoading: true }),

  [RECOVERY_PHONE_NUMBER_DELETE_SUCCESS]: (state, action) => {
    if (action) {
      return {
        ...state,
        data: {
          mobileNumber: '',
        },
        isLoading: false,
      };
    }
    return { ...state, isLoading: false };
  },

  [RECOVERY_PHONE_NUMBER_DELETE_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

  [RECOVERY_PHONE_NUMBER_VERIFY_CODE]: (state) => ({ ...state, isLoading: true }),

  [RECOVERY_PHONE_NUMBER_VERIFY_CODE_SUCCESS]: (state, action) => {
    if (typeof action.payload === "object") {
      return {
        ...state,
        isLoading: false,
      };
    }
    return { ...state, isLoading: false };
  },

  [RECOVERY_PHONE_NUMBER_VERIFY_CODE_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),
};

const recoveryPhoneNumberReducer = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};

export default recoveryPhoneNumberReducer;

